import React, { FC } from 'react';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FormItem, FiltersNameEnum, useFiltersLabel } from '@blocs.filter';
import { FilterDrawerType, FiltersCategoryNameEnum } from '../../shared/types';
import { HeightRange, WeightRange } from '../../FilterDrawerCollection';

interface Props {
  type: FilterDrawerType;
}

const HeightAndWeightCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { isCategoryMatchedSearch, shouldCategoryFilterBeVisible } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.heightAndWeight
  );

  return (
    isCategoryMatchedSearch && (
      <>
        {shouldCategoryFilterBeVisible(FiltersNameEnum.heightRange) && (
          <FormItem $fullWidth $marginValue={2}>
            <HeightRange
              heightRangeName={FiltersNameEnum.heightRange}
              switchHeightToMetricName={FiltersNameEnum.switchTo}
              heightMinName={FiltersNameEnum.min}
              heightMaxName={FiltersNameEnum.max}
              label={filtersLabelOfAudience[FiltersNameEnum.heightRange]}
            />
          </FormItem>
        )}
        {shouldCategoryFilterBeVisible(FiltersNameEnum.weightRange) && (
          <FormItem $fullWidth $marginValue={2}>
            <WeightRange
              weightRangeName={FiltersNameEnum.weightRange}
              switchWeightToMetricName={FiltersNameEnum.switchTo}
              weightMinName={FiltersNameEnum.min}
              weightMaxName={FiltersNameEnum.max}
              label={filtersLabelOfAudience[FiltersNameEnum.weightRange]}
            />
          </FormItem>
        )}
      </>
    )
  );
};

export default HeightAndWeightCategory;
